const genderList = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
  { label: "Unspecified", value: "X" },
];

export default genderList;
